module.exports = __webpack_public_path__ + "assets/ea8c30d36999ef5391509fac5084a487.jpg";